import React from 'react';
import { Link } from 'react-router-dom';
import SmtTicketSolutionModal from './SmtTicketSolutionModal';

const TicketSolutionButton = (props) => {
  const { source, incidentId, status, label, icon, localizationLabel } = props;

  return (
    <>
      {/* if the tickect is from SMT */}
      {String(source).toUpperCase() === 'SMT' && (
        <SmtTicketSolutionModal
          incidentId={incidentId}
          status={status}
          label={label}
          localizationLabel={localizationLabel}
          icon={icon}
        />
      )}

      {/* if the tickect is from SN or CPSC */}
      {['SN', 'CPSC'].includes(String(source).toUpperCase()) && (
        <Link
          to={`/cisco/tickets/ticket-journey/${incidentId}`}
          className="group border-none flex items-center justify-left no-underline bg-transparent border-2 m-0 p-0 h-14 w-auto text-blue_font hover:text-[#005580] text-[12px] normal-case"
        >
          <span className={`${icon} text-[16px] block pr-[5px]`}></span>
          <span className="capitalize block pr-[5px]">{localizationLabel}</span>
          <div className="transform -rotate-90 group-hover:translate-x-2">
            <span className={`boschicon-bosch-ic-down text text-[18px]`}></span>
          </div>
        </Link>
      )}
    </>
  );
};

export default TicketSolutionButton;
